<template>
  <div class="main-layout">
    <div
      ref="myDiv"
      class="sticky-top nav-bar"
    >
    </div>

    <div class="main-layout__container">
      <div
        class="main-layout__body"
        :style="mainLayoutBodyStyles"
      >
        <child />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'MainLayout',
  components: {
  },
  data () {
    return {
      lastScrollPosition: 0,
      showNavbar: true,
      navbarTop: 0
    }
  },
  computed: {
    ...mapState({
    }),
    ...mapGetters({

    }),
    mainLayoutBodyStyles() {
      return {
          minHeight:  '1000px',
          paddingLeft: '10px'
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions({

    }),
    handleScroll () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      this.navbarTop = -this.$refs.myDiv.offsetHeight
      if (currentScrollPosition > this.lastScrollPosition) {
        // Scrolling down
        this.showNavbar = false
      } else {
        // Scrolling up
        this.showNavbar = true
      }
      this.lastScrollPosition = currentScrollPosition
    },
  }
}
</script>

<style lang="scss" scoped>
  .main-layout__container{
    position: relative;
  }
  .main-layout__body{
    @media only screen and (max-width:560px){
      padding-left: 0 !important;
    }
  }
  .nav-bar {
    transition: top 0.3s ease-in-out;
  }
</style>
